import React from 'react';

const LensIcon = (props: any) => (
  <svg width="116" height="116" viewBox="0 0 116 116" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_d_3549_2190)">
      <circle cx="58" cy="44" r="23" fill="url(#paint0_linear_3549_2190)" />
    </g>
    <circle cx="56.4998" cy="42.5" r="6.5" fill="url(#paint1_linear_3549_2190)" fill-opacity="0.4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.8233 42.3236C62.8233 45.5398 60.216 48.147 56.9999 48.147C53.7837 48.147 51.1765 45.5398 51.1765 42.3236C51.1765 39.1075 53.7837 36.5002 56.9999 36.5002C60.216 36.5002 62.8233 39.1075 62.8233 42.3236ZM60.8794 50.2506C59.7085 50.8247 58.3918 51.147 56.9999 51.147C52.1269 51.147 48.1765 47.1966 48.1765 42.3236C48.1765 37.4506 52.1269 33.5002 56.9999 33.5002C61.8729 33.5002 65.8233 37.4506 65.8233 42.3236C65.8233 44.7228 64.8657 46.8983 63.3119 48.4889L66.1712 52.063C66.6887 52.7099 66.5838 53.6539 65.9369 54.1714C65.29 54.6889 64.3461 54.584 63.8286 53.9371L60.8794 50.2506Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.8233 42.3236C62.8233 45.5398 60.216 48.147 56.9999 48.147C53.7837 48.147 51.1765 45.5398 51.1765 42.3236C51.1765 39.1075 53.7837 36.5002 56.9999 36.5002C60.216 36.5002 62.8233 39.1075 62.8233 42.3236ZM60.8794 50.2506C59.7085 50.8247 58.3918 51.147 56.9999 51.147C52.1269 51.147 48.1765 47.1966 48.1765 42.3236C48.1765 37.4506 52.1269 33.5002 56.9999 33.5002C61.8729 33.5002 65.8233 37.4506 65.8233 42.3236C65.8233 44.7228 64.8657 46.8983 63.3119 48.4889L66.1712 52.063C66.6887 52.7099 66.5838 53.6539 65.9369 54.1714C65.29 54.6889 64.3461 54.584 63.8286 53.9371L60.8794 50.2506Z"
      fill="url(#paint2_linear_3549_2190)"
    />
    <defs>
      <filter
        id="filter0_d_3549_2190"
        x="0.652119"
        y="0.39127"
        width="114.696"
        height="114.696"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.7392" />
        <feGaussianBlur stdDeviation="17.1739" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.114792 0 0 0 0 0.258462 0 0 0 0 0.3625 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3549_2190" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3549_2190" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_3549_2190"
        x1="35.6602"
        y1="42.1931"
        x2="67.5328"
        y2="63.6056"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.primary || '#7528BE'} />
        <stop offset="1" stopColor={props.secondary || '#914FC7'} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3549_2190"
        x1="57.9442"
        y1="41.6136"
        x2="64.8347"
        y2="51.3837"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3549_2190"
        x1="59.2448"
        y1="42.961"
        x2="71.4188"
        y2="57.2306"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
    </defs>
  </svg>
);

export default LensIcon;
